<template>
     <div class="container-fluid g-2 web5__rowcard">
      <div class="row">
        <div class="col headline">
          <h2>Störungsmeldung erfassen</h2>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <form @submit.prevent="createMalFunctionCase()" class="form-signin">
            <div class="row">                
              <div class="col field__label">
              <label>Auftragsnummer</label>
              </div>
              <div class="col field__value">
                <input type="text" id="auftragsNummer" class="form-control" placeholder="" autocomplete="off" spellcheck="false" autocorrect="off" autocapitalize="off" readonly v-model="auftragNummer"/>
              </div>

              <div class="col field__labelsecond">
              <label>Eingangsdatum</label>
              </div>
              <div class="col field__value">
                <input type="text" id="eingangDatum" class="form-control" placeholder="" autocomplete="off" spellcheck="false" autocorrect="off" autocapitalize="off" readonly v-model="eingangDatum"/>
              </div>
            </div>

            <div class="row line__divider">                
              <div class="col field__label">
              <label>Ihre Referenz</label>
              </div>
              <div class="col field__value">
                <input type="text" id="ref1" class="form-control" placeholder="" autocomplete="off" spellcheck="false" autocorrect="off" autocapitalize="off" v-model="ref1"/>
              </div>

              <div class="col field__labelsecond">
              <label>Zusatz-Information</label>
              </div>
              <div class="col field__value">
                <input type="text" id="info" class="form-control" placeholder="" autocomplete="off" spellcheck="false" autocorrect="off" autocapitalize="off" v-model="info"/>
              </div>
            </div>

            <div class="row line__divider">                
              <div class="col field__label">
              <label>Repartur Gerät Telnr./Id</label>
              </div>
              <div class="col field__value">
                <input type="text" id="geraeteIdentifikation" class="form-control" placeholder="" autocomplete="off" spellcheck="false" autocorrect="off" autocapitalize="off" v-model="geraeteIdentifikation"/>
              </div>
              <div class="col field__labelsecond">
                <label></label>
              </div>
              <div class="col field__value">
                <label></label>
              </div>
            </div>

            <div class="row line__divider">                
              <div class="col field__label">
              <label>Firma</label>
              </div>
              <div class="col field__value">
                <input type="text" id="firma" class="form-control" placeholder="" autocomplete="off" spellcheck="false" autocorrect="off" autocapitalize="off" v-model="firma"/>
              </div>

              <div class="col field__labelsecond">
              <label>Abteilung</label>
              </div>
              <div class="col field__value">
                <input type="text" id="abteilung" class="form-control" placeholder="" autocomplete="off" spellcheck="false" autocorrect="off" autocapitalize="off" v-model="abteilung"/>
              </div>
            </div>

            <div class="row line__divider">                
              <div class="col field__label">
              <label>Vorname</label>
              </div>
              <div class="col field__value">
                <input type="text" id="vorname" class="form-control" placeholder="" autocomplete="off" spellcheck="false" autocorrect="off" autocapitalize="off" v-model="vorName"/>
              </div>

              <div class="col field__labelsecond">
              <label>Name</label>
              </div>
              <div class="col field__value">
                <input type="text" id="name" class="form-control" placeholder="" autocomplete="off" spellcheck="false" autocorrect="off" autocapitalize="off" v-model="name"/>
              </div>
            </div>

            <div class="row line__divider">                
              <div class="col field__label">
              <label>Strasse</label>
              </div>
              <div class="col field__value">
                <input type="text" id="strasse" class="form-control" placeholder="" autocomplete="off" spellcheck="false" autocorrect="off" autocapitalize="off" v-model="strasse"/>
              </div>

              <div class="col field__labelsecond">
              <label>Hausnummer</label>
              </div>
              <div class="col field__value">
                <input type="text" id="hausnummer" class="form-control" placeholder="" autocomplete="off" spellcheck="false" autocorrect="off" autocapitalize="off" v-model="hausNummer"/>
              </div>
            </div>

            <div class="row line__divider">                
              <div class="col field__label">
              <label>Plz</label>
              </div>
              <div class="col field__value">
                <input type="text" id="plz" class="form-control" placeholder="" autocomplete="off" spellcheck="false" autocorrect="off" autocapitalize="off" v-model="plz"/>
              </div>

              <div class="col field__labelsecond">
              <label>Ort</label>
              </div>
              <div class="col field__value">
                <input type="text" id="ort" class="form-control" placeholder="" autocomplete="off" spellcheck="false" autocorrect="off" autocapitalize="off" v-model="ort"/>
              </div>
            </div>

            <div class="row line__divider">                
              <div class="col field__label">
              <label>Telefonnummer</label>
              </div>
              <div class="col field__value">
                <input type="text" id="telefonNummer" class="form-control" placeholder="" autocomplete="off" spellcheck="false" autocorrect="off" autocapitalize="off" v-model="telefonNr"/>
              </div>

              <div class="col field__labelsecond">
              <label>E-Mail</label>
              </div>
              <div class="col field__value">
                <input type="text" id="emailAdresse" class="form-control" placeholder="" autocomplete="off" spellcheck="false" autocorrect="off" autocapitalize="off" v-model="emailAdresse"/>
              </div>
            </div>

            <div class="row line__divider">                
              <div class="col field__label">
              <label>Meldung</label>
              </div>
              <div class="col field__meldung">
                <textarea rows="4" cols="50"  id="meldung" class="form-control"  autocomplete="off" spellcheck="false" autocorrect="off" autocapitalize="off" v-model="meldung"/>
              </div>
            </div>

            <div class="row line__divider">
              <div class="col field__label">

            </div>
              <div class="col checks">
                <strong>Bitte beachten:</strong> <br />
                Wenn es sich um ein Akku/Ladeproblemen handelt, dann legen Sie bitte das nachfolgende Zubehör bei!
              </div>
            </div>

            <div class="row line__divider">                
              <div class="col field__label--check">
                <input type="checkbox" id="netzTeil" class="form-check-input" v-model="netzteil"/>
              </div>
              <div class="col  field__checkbox">
              <label>230V-Netzteil</label>
              </div>
            </div>

            <div class="row line__divider">                
              <div class="col field__label--check">
                <input type="checkbox" id="kabel" class="form-check-input" v-model="kabel"/>
              </div>
              <div class="col  field__checkbox">
              <label>USB-Kabel</label>
              </div>
            </div>

            <div class="row line__divider">                
              <div class="col field__label--check">
                <input type="checkbox" id="ladestation" class="form-check-input" v-model="ladestation"/>
              </div>
              <div class="col  field__checkbox">
              <label>Ladestation</label>
              </div>
            </div>

            <div class="row line__divider">                
              <div class="col field__label--check">
                <input type="checkbox" id="ladeadapter" class="form-check-input" v-model="ladeadapter"/>
              </div>
              <div class="col  field__checkbox">
              <label>Ladeadapter</label>
              </div>
            </div>

            <div class="row line__divider">
              <div class="col field__label">

            </div>
              <div class="col checks__second">
                <strong>Ihre Reparaturvorgabe:</strong> <br />               
              </div>
            </div>


            <div class="row line__divider">                
              <div class="col field__label--check">
                <input type="checkbox" id="kostendach" class="form-check-input" v-model="kostendach"/>
              </div>
              <div class="col field__checkbox">
              <label>Kostendach für Reparatur Fr. 250.- (bis zu diesem Betrag wird die Reparatur umgehend ausgeführt) </label>
              </div>
            </div>

            <div class="row line__divider">                
              <div class="col field__label--check">
                <input type="checkbox" id="kostenvoranschlag" class="form-check-input" v-model="kostenvoranschlag"/>
              </div>
              <div class="col  field__checkbox">
              <label>Reparatur-Kostenvoranschlag: Fr. 48.- (innert ca. 5 Arbeitstagen wird dieser Ihnen zugestellt)</label>
              </div>
            </div>

            <div class="row line__divider">                
              <div class="col field__label--check">
                <input type="checkbox" id="garantieAnspruch" class="form-check-input" v-model="garantieAnspruch"/>
              </div>
              <div class="col  field__checkbox">
              <label>Garantie-Anspruch: Garantieschein/Rechnungskopie wird zusammen mit dem Gerät versendet</label>
              </div>
            </div>

            <div class="row centered">
              <div class="col-6 form__button--alignment">
                <button :disabled="saved" class="btn btn-primary form__button--view">Reparaturfall absenden</button>
              </div>
              <div v-if="saved" class="col saved">
                <img src="img/icon/icons8-ok-48.png" alt="Bitte warten ...">
              </div>
            </div>
          </form>
      </div>
    </div>
  </div>
  <div v-if="spinner" class ="spinner__centered">
    <img src="img/icon/icons8-spinner.gif" alt="Bitte warten ...">
  </div>
</template>

<script language="ts">
import {reactive, ref, toRefs} from "vue"
import { apiPost } from "@/services/api/fetchapi";
import { useStore } from "vuex";
import router from "@/router/index"

export default {
  name: "RecordMalfunction",
  inheritAttrs: false,
  components: {},
  setup() {
   
    const store = new useStore();
    const spinner = ref(false);
    const saved = ref(false);

    let timerId = {}

    const stoerungsMeldung = reactive({
      auftragNummer: "",
      eingangDatum: "",
      ref1: "",
      ref2: "",
      info: "",
      geraeteIdentifikation: "",
      firma: "",
      abteilung: "",
      vorName: "",
      name: "",
      strasse: "",
      hausNummer: "",
      plz: "",
      ort: "",
      telefonNr: "",
      emailAdresse: "",
      meldung: "",
      kostendach: false,
      kostenvoranschlag: false,
      garantieAnspruch: false,
      netzteil: false,
      kabel: false,
      ladestation: false,
      ladeadapter: false,
      received: false
      })

    async function getProfileInfo() {
      spinner.value = true;
      stoerungsMeldung.ref1 = "";
      stoerungsMeldung.ref2 = "";
      stoerungsMeldung.geraeteIdentifikation = "";
      stoerungsMeldung.firma = "";
      stoerungsMeldung.vorName = "";
      stoerungsMeldung.name = "";
      stoerungsMeldung.emailAdresse = "";
      stoerungsMeldung.strasse = "";
      stoerungsMeldung.plz = "";
      stoerungsMeldung.ort = "";
      stoerungsMeldung.telefonNr = "";
      stoerungsMeldung.auftragNummer = "";
      stoerungsMeldung.eingangDatum = "";
      stoerungsMeldung.hausNummer = "";
      stoerungsMeldung.meldung = "";
      stoerungsMeldung.kostendach = false;
      stoerungsMeldung.kostenvoranschlag = false;
      stoerungsMeldung.garantieAnspruch = false;
      stoerungsMeldung.netzteil = false;
      stoerungsMeldung.kabel = false;
      stoerungsMeldung.ladestation = false;
      stoerungsMeldung.ladeadapter = false;
      stoerungsMeldung.received = false;

      const response = await apiPost("ComponentView/getProfileInfo", {
        userId: store.getters["userstore/getUser"]
      });

      stoerungsMeldung.auftragNummer = response.auftragNummer;
      stoerungsMeldung.eingangDatum = response.eingangDatum
      stoerungsMeldung.firma = response.firma;
      stoerungsMeldung.vorName = response.vorName;
      stoerungsMeldung.name = response.name;
      stoerungsMeldung.emailAdresse = response.emailAdresse;
      stoerungsMeldung.strasse = response.strasse;
      stoerungsMeldung.plz = response.plz;
      stoerungsMeldung.ort = response.ort;
      stoerungsMeldung.telefonNr = response.telefonNr;
      spinner.value = false;
      saved.value = false;
    }

    async function createMalFunctionCase() {
      saved.value = false;
      const response = await apiPost("ComponentView/CreateMalfunctionTask", {
        userId: store.getters["userstore/getUser"],
        auftragNummer: stoerungsMeldung.auftragNummer,
        eingangDatum: stoerungsMeldung.eingangDatum,
        ref1: stoerungsMeldung.ref1,
        info: stoerungsMeldung.info,
        geraeteIdentifikation: stoerungsMeldung.geraeteIdentifikation,
        firma: stoerungsMeldung.firma,
        abteilung: stoerungsMeldung.abteilung,
        vorName: stoerungsMeldung.vorName,
        name: stoerungsMeldung.name,
        strasse: stoerungsMeldung.strasse,
        hausNummer: stoerungsMeldung.hausNummer,
        plz: stoerungsMeldung.plz,
        ort: stoerungsMeldung.ort,
        telefonNr: stoerungsMeldung.telefonNr,
        emailAdresse: stoerungsMeldung.emailAdresse,
        meldung: stoerungsMeldung.meldung,
        kostendach: stoerungsMeldung.kostendach,
        kostenvoranschlag: stoerungsMeldung.kostenvoranschlag,
        garantieAnspruch: stoerungsMeldung.garantieAnspruch,
        netzteil: stoerungsMeldung.netzteil,
        kabel: stoerungsMeldung.kabel,
        ladestation: stoerungsMeldung.ladestation,
        ladeadapter: stoerungsMeldung.ladeadapter,
        received: false
      });
      saved.value = true;
      timerId = setTimeout(() => { waitForReset() }, 10000);

    }

    function waitForReset() {
      saved.value = true;      
    }

    getProfileInfo();

    router.beforeEach((to, from, next) => {
      if (to.name === "RecordMalfunction") {
        getProfileInfo();
      }
      next();
     });

      return {
      ...toRefs(
          stoerungsMeldung,
          stoerungsMeldung.auftragNummer,
          stoerungsMeldung.eingangDatum,
          stoerungsMeldung.ref1,
          stoerungsMeldung.ref2,
          stoerungsMeldung.info,
          stoerungsMeldung.geraeteIdentifikation,
          stoerungsMeldung.firma,
          stoerungsMeldung.abteilung,
          stoerungsMeldung.vorName,
          stoerungsMeldung.name,
          stoerungsMeldung.strasse,
          stoerungsMeldung.hausNummer,
          stoerungsMeldung.plz,
          stoerungsMeldung.ort,
          stoerungsMeldung.telefonNr,
          stoerungsMeldung.emailAdresse,
          stoerungsMeldung.meldung,
          stoerungsMeldung.kostendach,
          stoerungsMeldung.kostenvoranschlag,
          stoerungsMeldung.garantieAnspruch,
          stoerungsMeldung.netzteil,
          stoerungsMeldung.kabel,
          stoerungsMeldung.ladestation,
          stoerungsMeldung.ladeadapter
        ),
        createMalFunctionCase,
        spinner,
        saved
      }
  },
}
</script>
<style scoped language="scss">
  .spinner__centered {
    position: fixed;
    left: 460px;
    top: 400px;
    z-index: 999;     
  }

  .web5__rowcard {
    max-width: 95% !important;
    margin-top: 10px;
    margin-bottom: 10px;
    min-width: 800px;
  }

  .saved {
    text-align: left;
  }

  .checks {
    text-align: left;
    margin-top: 10px;
  }

  .checks__second {
    text-align: left;
    margin-top: 20px;
  }

  .centered {
    align-items: flex-end;
    
  }

  .field__label {
    max-width: 180px;
    padding-top: 5px;
    padding-bottom: 2px;
    text-align: left;
  }

  .field__label--check {
    max-width: 180px;
    padding-top: 5px;
    padding-bottom: 2px;
    text-align: right;
    padding-right: 10px;
  }



  .field__labelsecond {
    max-width: 180px;
    padding-top: 5px;
    padding-bottom: 2px;
    text-align: left;
    margin-left: 20px
  }

.field__value {
    max-width: 300px;
  }

.field__meldung {
  max-width: 800px;
  
}

.field__checkbox {
  margin-top: 10px;
  max-width: 800px;
  text-align: left;
}

  .headline {
    text-align: left;
    padding-bottom: 25px;
  }

  .field__description {
    max-width: 600px;
  }
  
   .form__button--alignment {
     text-align: left;
   }

   .form__button--view {
     max-width: 240px;
     margin-top: 40px;     
   }

   .line__divider {
     margin-top: 10px;
   }


</style>